import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Form, ProgressBar } from "react-bootstrap";
import { listStaffOrders } from "../../services/requirementsService";
import { errorToast } from "../Toasts/Toasts";

// CMS: orders to fulfil, newest first, with delivery progress.
const inr = (n) => (n === null || n === undefined ? "—" : `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`);
const STATUSES = ["Awaiting PO", "Confirmed", "Preparing", "Ready for Dispatch", "Dispatched", "Partially Delivered", "Delivered", "Completed", "Cancelled"];

const OrdersQueue = () => {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("active");
  const load = useCallback(async () => {
    try { setRows(await listStaffOrders({ status: status || undefined })); } catch (e) { errorToast("Could not load orders"); }
  }, [status]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="page-body px-0 py-lg-2 py-1 mt-0 mt-lg-3 ms-3">
      <div className="container-fluid p-0">
        <div className="row-title px-2 d-flex justify-content-between align-items-center">
          <h6 className="fw-bold mb-0">Orders</h6>
          <Form.Select size="sm" value={status} onChange={(e) => setStatus(e.target.value)} style={{ width: 200 }}>
            <option value="active">Active</option>
            <option value="">All</option>
            {STATUSES.map((s) => <option key={s}>{s}</option>)}
          </Form.Select>
        </div>
        <div className="card mt-2">
          <div className="card-body p-0">
            <table className="table table-hover table-sm mb-0 align-middle">
              <thead><tr><th>Order</th><th>Customer</th><th>Status</th><th>Needed by</th><th>PO</th><th className="text-end">Total</th><th style={{ width: 160 }}>Delivered</th></tr></thead>
              <tbody>
                {rows.map((o) => (
                  <tr key={o.id}>
                    <td><Link to={`/orders/${o.id}`}>{o.orderNumber}</Link></td>
                    <td>{o.organizationName}</td>
                    <td><span className="badge bg-light text-dark">{o.status}</span></td>
                    <td>{o.deliveryDate || "—"}</td>
                    <td>{o.customerPoNumber || "—"}</td>
                    <td className="text-end">{inr(o.totals?.grand)}</td>
                    <td><ProgressBar now={o.deliveredPct} label={`${o.deliveredPct}%`} variant="success" style={{ height: 14 }} /></td>
                  </tr>
                ))}
                {!rows.length && <tr><td colSpan={7} className="text-muted text-center py-4">No orders.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrdersQueue;
